import { render, staticRenderFns } from "./CarrosselStepAparencia.vue?vue&type=template&id=b78b243a&scoped=true&"
import script from "./CarrosselStepAparencia.vue?vue&type=script&lang=js&"
export * from "./CarrosselStepAparencia.vue?vue&type=script&lang=js&"
import style0 from "./CarrosselStepAparencia.vue?vue&type=style&index=0&id=b78b243a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b78b243a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VColorPicker } from 'vuetify/lib/components/VColorPicker';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VColorPicker,VDivider,VIcon,VRow})
